function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/*jshint esversion: 8 */
import { OAuthService } from "./Services/OAuthService";
import { UserService } from "./Services/UserService";
import { MyGivingsApiService } from "./Services/MyGivingsApiService";
import { ComponentBase } from "./Shared/ComponentBase";
import { I18N } from "./Shared/I18n";
import * as CanvasJS from './Libraries/canvasjs.min';
import { NumberUtils } from './Helpers/NumberUtils'; //var CanvasJS = require('./Libraries/canvasjs.min')

export var MppMyGiving = /*#__PURE__*/function (_ComponentBase) {
  _inherits(MppMyGiving, _ComponentBase);

  var _super = _createSuper(MppMyGiving);

  function MppMyGiving() {
    _classCallCheck(this, MppMyGiving);

    return _super.call(this);
  }

  _createClass(MppMyGiving, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldValue, newValue) {
      console.log('Attribute changed', newValue);
      this.loadAttributes();
      if (!this._$widgetReady) return;

      if (this.hideSoftCredits) {
        this._$softCreditControlRow.style.display = "none";
        this._$softCreditDonationSubtitle.style.display = "none";
        this._$includeSoftCredits.checked = false;
      } else {
        this._$softCreditControlRow.style.display = "";
        this._$softCreditDonationSubtitle.style.display = "";
        this._$includeSoftCredits.checked = false;
      }
    }
  }, {
    key: "loadAttributes",
    value: function loadAttributes() {
      var _this$getAttribute;

      this.hideSoftCredits = ((_this$getAttribute = this.getAttribute("hidesoftcredits")) === null || _this$getAttribute === void 0 ? void 0 : _this$getAttribute.toLowerCase()) === "true" || false;
    } // istanbul ignore next

  }, {
    key: "createI18N",
    value: function createI18N() {
      return new I18N("mpp-my-giving");
    } // istanbul ignore next

  }, {
    key: "getRoot",
    value: function getRoot(i18n) {
      return  `<link href="${this._appRoot}/Content/mppw-widgetstyles.css" rel="stylesheet" type="text/css"/><div class="mppw-component-container"><div class="mppw-form-wrapper" id="myGivingWrapper" style="display: none;"><h1>${ i18n.pageTitle }</h1></div><div id="loadingContainer"><i class="mppw-spinner"></i></div><div id="emptyContainer" style="display: none;"></div><div id="loginButtonContainer" class="mppw-centered" style="display: none;"><div id="myGivingNotLoggedIn" class="mppw-alert mppw-alert__warning"><div class="mppw-alert__icon"></div><span class="mppw-alert__text">${this._i18n.pleaseLoginMessage}</span></div><input type="button" class="mppw-btn primary" id="loginButton" value="Login"/></div><div class="results-container" id="myGivingsContainer" style="display:none"><div class="givings-container"><div class="filters-row"><div class="prev-year" id="previousYearButton"><span></span> <span id="previousYearLabel">2022</span></div><select name="monthId" class="mppw-form-field__control search-option" id="monthSelector" value=""></select><div class="next-year" id="nextYearButton"><span id="nextYearLabel">2022</span> <span></span></div></div><div class="soft-credit-row"><label class="mpp-card-multiselect--checkbox-small"><input type="checkbox" id="include_softCredits" name="softCreditsCheckbox"/> <span style="float: left;"></span></label> <label class="mpp-subscriptions--checkboxlabel" style="vertical-align: -2px" for="include_softCredits">${ i18n.includeSoftCredit }</label></div><div class="total-giving-row"><span>${ i18n.totalGiving }</span><span id="totalGivingValue">$0,000</span></div><div class="graphs-container"><div class="by-month-chart"><div class="chart-title">${ i18n.byMonth }</div><div id="monthChartContainer" style="height: 370px; max-width: 920px; margin: 0px auto;"></div></div><div class="by-program-chart"><div class="chart-title title-padding">${ i18n.byProgram }</div><div id="programChartContainer" style="height: 370px; max-width: 630px; margin: 0px 0px;"></div></div></div></div><div class="donations-container"><div><div class="donations-title">${ i18n.donations }</div><div class="donations-subtitle">${ i18n.donationsSubtitle }</div><div class="soft-credits-subtitle" style="display: none">${ i18n.softDonationsSubtitle }</div></div><div class="donations-list-container"></div><div class="show-more-button">${ i18n.moreDonationsBtn }</div><div class="no-donations">${ i18n.noDonations }</div></div></div></div>` ;
    }
  }, {
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var i18n;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log("[mpp-my-giving.js] Loading my giving...");
                _context.prev = 1;
                _context.next = 4;
                return this.createI18N();

              case 4:
                i18n = _context.sent;
                _context.next = 11;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](1);

                if (_context.t0.toString().startsWith("TypeError")) {
                  this._root.innerHTML = "Unable to connect.  Please check Permitted URLs.";
                } else {
                  this._root.innerHTML = "".concat(_context.t0);
                }

                return _context.abrupt("return");

              case 11:
                this._i18n = i18n; // Load initial values of tag attributes:

                this.loadAttributes(); // Default values

                this._$selectedYear = new Date().getFullYear();
                this._$selectedMonth = -1; //console.log(`Mon: `, (new Date()).getMonth() + 1)
                // Root Html

                this._root.innerHTML = this.getRoot(this._i18n);
                this._$myGivingWrapper = this._root.querySelector("#myGivingWrapper");
                this._$resultsContainer = this._root.querySelector("#resultsContainer");
                this._$loadingContainer = this._root.querySelector("#loadingContainer");
                this._$emptyContainer = this._root.querySelector("#emptyContainer");
                this._$loginButtonContainer = this._root.querySelector("#loginButtonContainer");
                this._$loginButton = this._root.querySelector("#loginButton");
                this._$myGivingsContainer = this._root.querySelector("#myGivingsContainer");
                this._$softCreditControlRow = this._root.querySelector(".soft-credit-row");

                if (this.hideSoftCredits) {
                  this._$softCreditControlRow.style.display = "none";
                }

                this._$includeSoftCredits = this._root.querySelector("#include_softCredits");
                this._$totalGivingsValue = this._root.querySelector("#totalGivingValue");
                this._$donationListContainer = this._root.querySelector(".donations-list-container");
                this._$showMoreButton = this._root.querySelector(".show-more-button");
                this._$graphsContainer = this._root.querySelector(".graphs-container");
                this._$noDonationsRow = this._root.querySelector(".no-donations");
                this._$byMonthChart = this._root.querySelector(".by-month-chart"); // Date Labels

                this._$previousYearButton = this._root.querySelector("#previousYearButton");
                this._$nextYearButton = this._root.querySelector("#nextYearButton");
                this._$previousYearLabel = this._root.querySelector("#previousYearLabel");
                this._$nextYearLabel = this._root.querySelector("#nextYearLabel");
                this._$monthSelector = this._root.querySelector("#monthSelector");
                this._$selectedYearLabel = this._root.querySelectorAll(".selectedYearLabel");
                this.showFullList = false;
                this._$showMoreButton.style.display = "none";
                this.SetDatesLabels(); // Set buttons values

                this._$softCreditDonationSubtitle = this._root.querySelector(".soft-credits-subtitle"); // Try logging in user

                this.TryLoginUser();

                this._$loginButton.addEventListener("click", function () {
                  OAuthService.SignIn();
                });

                this._$showMoreButton.addEventListener("click", function () {
                  _this.showFullList = true;
                  _this._$showMoreButton.style.display = "none";

                  _this.renderDonationsList(_this.showFullList);
                });

                this._$includeSoftCredits.addEventListener("change", function (e) {
                  //Only show blank form if drop down value is null
                  if (e.currentTarget.checked) {
                    _this._$softCreditDonationSubtitle.style.display = "";
                  } else {
                    _this._$softCreditDonationSubtitle.style.display = "none";
                  }

                  _this.showFullList = false;

                  _this.renderPieChart(_this._$data, _this._$includeSoftCredits.checked, _this._$selectedMonth);

                  _this.renderDonationsList();
                });

                this._$monthSelector.addEventListener("change", function (e) {
                  _this._$selectedMonth = _this._$monthSelector.value;

                  if (_this._$selectedMonth == -1) {
                    _this._$byMonthChart.style.display = "";
                  } else {
                    _this._$byMonthChart.style.display = "none";
                  }

                  _this.GetMyDonations();
                });

              case 47:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 7]]);
      }));

      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }

      return connectedCallback;
    }()
  }, {
    key: "SetDatesLabels",
    value: function SetDatesLabels() {
      this._$previousYearLabel.innerHTML = this._$selectedYear - 1;
      this._$nextYearLabel.innerHTML = this._$selectedYear + 1;
      var i,
          L = this._$monthSelector.options.length - 1;

      for (i = L; i >= 0; i--) {
        this._$monthSelector.remove(i);
      }

      var currentYear = new Date().getFullYear();
      var currentMonth = new Date().getMonth();

      this._$monthSelector.options.add(new Option("".concat(this._i18n.allMonths, " ").concat(this._$selectedYear), '-1', this._$selectedMonth == -1, this._$selectedMonth == -1));

      for (var _i = 0; _i < 12; _i += 1) {
        var opt = new Option("".concat(this._i18n['month' + (_i + 1)], " ").concat(this._$selectedYear), "".concat(_i + 1), this._$selectedMonth == _i + 1, this._$selectedMonth == _i + 1);
        opt.disabled = this._$selectedYear === currentYear && _i > currentMonth;

        this._$monthSelector.options.add(opt);
      }

      if (this._$selectedYear >= new Date().getFullYear()) {
        this._$nextYearButton.classList.add("button-disabled");
      } else {
        this._$nextYearButton.classList.remove("button-disabled");
      }

      if (this._$selectedYear <= new Date().getFullYear() - 4) {
        this._$previousYearButton.classList.add("button-disabled");
      } else {
        this._$previousYearButton.classList.remove("button-disabled");
      }
    }
  }, {
    key: "TryLoginUser",
    value: function TryLoginUser() {
      var _this2 = this;

      this._$myGivingsContainer.style.display = "none";
      this._$loadingContainer.style.display = "";
      UserService.GetCurrentUser().then(function (userInfo) {
        _this2._$loginButtonContainer.style.display = "none";
        _this2._$myGivingWrapper.style.display = "";
        _this2._$widgetReady = true;

        _this2.GetMyDonations();

        _this2._$nextYearButton.addEventListener("click", function () {
          _this2._$selectedYear += 1;
          _this2._$selectedMonth = -1;

          _this2.SetDatesLabels();

          _this2.GetMyDonations();
        });

        _this2._$previousYearButton.addEventListener("click", function () {
          _this2._$selectedYear -= 1;
          _this2._$selectedMonth = -1;

          _this2.SetDatesLabels();

          _this2.GetMyDonations();
        });
      }, function () {
        console.log("User load error");
        _this2._$myGivingWrapper.style.display = "none";
        _this2._$myGivingsContainer.style.display = "none";
        _this2._$loginButtonContainer.style.display = "";
        _this2._$loadingContainer.style.display = "none";
      });
    } // istanbul ignore next

  }, {
    key: "getMyGivingsService",
    value: function getMyGivingsService() {
      return new MyGivingsApiService();
    }
  }, {
    key: "GetMyDonations",
    value: function GetMyDonations() {
      var _this3 = this;

      this._$myGivingsContainer.style.display = "none";
      this._$loadingContainer.style.display = "";
      this._$graphsContainer.style.display = "";
      this._$donationListContainer.style.display = "";
      this._$noDonationsRow.style.display = "none";
      var myGivingsService = this.getMyGivingsService();
      return myGivingsService.GetDonationsData(this._$selectedYear, this._$selectedMonth > 0 ? this._$selectedMonth : undefined).then(function (data) {
        _this3._$myGivingsContainer.style.display = "";
        _this3._$loadingContainer.style.display = "none";
        _this3.showFullList = false;
        _this3._$data = data;

        _this3.renderPieChart(data, _this3._$includeSoftCredits.checked, _this3._$selectedMonth);

        _this3.renderDonationsList();

        if (data.length <= 0) {
          _this3._$graphsContainer.style.display = "none";
          _this3._$donationListContainer.style.display = "none";
          _this3._$noDonationsRow.style.display = "";
        }

        if (data.filter(function (x) {
          return x.isSoftCredit;
        }).length <= 0) {
          _this3._$softCreditControlRow.style.display = "none";
          _this3._$softCreditDonationSubtitle.style.display = "none";
          _this3._$includeSoftCredits.checked = false;
        } else {
          if (!_this3.hideSoftCredits) {
            _this3._$softCreditControlRow.style.display = "";
            _this3._$softCreditDonationSubtitle.style.display = "";
            _this3._$includeSoftCredits.checked = false;
          }
        }
      })["catch"](function (error) {
        console.error(error);
        _this3._$loadingContainer.style.display = "none";
      });
    }
  }, {
    key: "renderDonationsList",
    value: function renderDonationsList() {
      var _this4 = this;

      this._$donationListContainer.innerHTML = ""; //console.log(`Soft?: `, this._$includeSoftCredits.checked)

      var filteredData = this._$includeSoftCredits.checked ? this._$data : this._$data.filter(function (x) {
        return !x.isSoftCredit;
      });

      if (filteredData.length <= 0) {
        this._$graphsContainer.style.display = "none";
        this._$donationListContainer.style.display = "none";
        this._$noDonationsRow.style.display = "";
      } else {
        this._$graphsContainer.style.display = "";
        this._$donationListContainer.style.display = "";
        this._$noDonationsRow.style.display = "none";
      } //console.log(`Res: `, filteredData)


      if (!this.showFullList) {
        if (filteredData.length > 4) {
          this._$showMoreButton.style.display = "";
        }

        filteredData = filteredData.slice(0, 4);

        if (filteredData.length <= 0) {
          this._$showMoreButton.style.display = "none";
        }
      }

      filteredData.forEach(function (record) {
        var row = document.createElement("div");
        row.className = "donation-row";
        var donationDate = document.createElement("div");
        donationDate.className = "donation-date";
        if (record.isPending) donationDate.innerHTML = "PENDING";else donationDate.innerHTML = "".concat(new Date(record.donationDate).toLocaleDateString());
        var donationName = document.createElement("div");
        donationName.className = "donation-name";
        donationName.innerHTML = "".concat(record.statementTitle);
        var donationBadges = document.createElement("div");
        donationBadges.className = "donation-badges";
        var donationSpouse = document.createElement("div");
        donationSpouse.className = "donation-spouse";
        donationSpouse.innerHTML = "".concat(_this4._i18n.spouseLabel);
        if (!record.isSpouseDonation) donationSpouse.style.display = "none";
        var donationSoftCredit = document.createElement("div");
        donationSoftCredit.className = "donation-soft-credit";
        donationSoftCredit.innerHTML = "".concat(_this4._i18n.softCreditLabel);

        if (!record.isSoftCredit) {
          donationSoftCredit.style.display = "none";
        }

        donationBadges.appendChild(donationSpouse);
        donationBadges.appendChild(donationSoftCredit);
        var donationAmount = document.createElement("div");
        donationAmount.className = "donation-amount";

        if (record.isOmitAmount) {
          donationAmount.innerHTML = "";
        } else {
          donationAmount.innerHTML = "".concat(NumberUtils.toCurrencyString(record.amount));
        }

        row.appendChild(donationDate);
        row.appendChild(donationName);
        row.appendChild(donationBadges);
        row.appendChild(donationAmount);

        _this4._$donationListContainer.appendChild(row);
      });
    } // istanbul ignore next

  }, {
    key: "getChart",
    value: function getChart(elm, options) {
      return new CanvasJS.Chart(elm, options);
    }
  }, {
    key: "renderPieChart",
    value: function renderPieChart(donationsData) {
      var _this5 = this;

      var includeSoftCredits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var selectedMonth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
      var filteredData = includeSoftCredits ? donationsData : donationsData.filter(function (x) {
        return !x.isSoftCredit;
      });
      this._$totalGivingsValue.innerHTML = "".concat(NumberUtils.toCurrencyString(donationsData.filter(function (x) {
        return !x.isSoftCredit;
      }).reduce(function (acc, curr) {
        return acc += curr.amount;
      }, 0)));
      var programChartData = filteredData.reduce(function (acc, curr) {
        var record = acc.find(function (x) {
          return x.programId == curr.programId;
        });

        if (record) {
          record.y += curr.amount;
        } else {
          acc.push({
            y: curr.amount,
            name: curr.programName,
            programId: curr.programId
          });
        }

        return acc;
      }, []).map(function (x) {
        return _objectSpread(_objectSpread({}, x), {}, {
          value: "".concat(NumberUtils.toCurrencyString(Math.floor(x.y * 100) / 100))
        });
      });
      var programChart = this.getChart(this._root.querySelector("#programChartContainer"), {
        animationEnabled: false,
        interactivityEnabled: false,
        legend: {
          itemTextFormatter: function itemTextFormatter(e) {
            return "" + e.dataPoint.name + " - " + e.dataPoint.value;
          },
          //dockInsidePlotArea: true,
          verticalAlign: "bottom",
          horizontalAlign: "left" //maxWidth: 200

        },
        toolTip: {
          enabled: false
        },
        data: [{
          type: "doughnut",
          startAngle: 270,
          showInLegend: true,
          dataPoints: programChartData
        }]
      });
      programChart.render();
      var monthChartData = filteredData.reduce(function (acc, curr) {
        var recordMonth = new Date(curr.donationDate).getMonth();
        var record = acc.find(function (x) {
          return x.monthNumber == recordMonth;
        });

        if (record) {
          record.y += curr.amount;
        } else {
          acc.push({
            y: curr.amount,
            monthNumber: recordMonth,
            label: _this5.getMonthLabel(recordMonth)
          });
        }

        return acc;
      }, this.generateInitialMonths()).map(function (x) {
        return _objectSpread(_objectSpread({}, x), {}, {
          amount: "".concat(NumberUtils.toCurrencyString(Math.floor(x.y * 100) / 100))
        });
      });
      monthChartData.sort(function (a, b) {
        return a.monthNumber - b.monthNumber;
      });
      var axisX = null;

      if (selectedMonth != -1) {
        axisX = {
          interval: 1
        };
      }

      var monthChart = this.getChart(this._root.querySelector("#monthChartContainer"), {
        animationEnabled: false,
        interactivityEnabled: true,
        axisX: selectedMonth == -1 ? {
          interval: 1
        } : null,
        dataPointMaxWidth: 20,
        toolTip: {
          contentFormatter: function contentFormatter(e) {
            return e.entries[0].dataPoint.amount;
          }
        },
        axisY: {
          labelFormatter: function labelFormatter(e) {
            return NumberUtils.toCurrencyString(e.value);
          }
        },
        data: [{
          type: "column",
          color: "#1A88B0",
          dataPoints: monthChartData
        }]
      });
      monthChart.render();
    }
  }, {
    key: "generateInitialMonths",
    value: function generateInitialMonths() {
      var currentYear = new Date().getFullYear();
      var currentMonth = new Date().getMonth();
      var month = 0,
          maxMonth = currentYear === this._$selectedYear ? currentMonth : 11;
      var data = [];

      while (month <= maxMonth) {
        data.push({
          y: 0,
          monthNumber: month,
          label: this.getMonthLabel(month)
        });
        month += 1;
      }

      return data;
    }
  }, {
    key: "getMonthLabel",
    value: function getMonthLabel(monthNumber) {
      return ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"][monthNumber];
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ["hidesoftcredits"];
    }
  }]);

  return MppMyGiving;
}(ComponentBase);
MppMyGiving.registerComponent("mpp-my-giving", MppMyGiving);